import React, { useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BiChevronLeft, BiChevronRight, BiDotsVerticalRounded, BiLinkAlt, BiOutline, BiPackage, BiImage, BiBox } from 'react-icons/bi'
import { BtnNextImg, BtnOptionsCard, ContIconInfo, ContIconsInfo, ContImgCard } from '../../../../../../../assets/css/components/admin/marketplace-to-marketplace/cardItem/CardItemStyle'

export default function CardContImage({ urlImage, setShowMenu, dataIconInfo }) {
    const [imgPosition, setImgPosition] = useState(0);

    const toggleMenu = () => {
        setShowMenu(true)
    }

    const nextImg = () => {
        if (!urlImage?.length) return;
        const maxImg = urlImage.length - 1;
        if (imgPosition === maxImg) return;
        setImgPosition(imgPosition + 1);
    }
    const backImg = () => {
        if (!urlImage?.length) return;
        if (imgPosition === 0) return;
        setImgPosition(imgPosition - 1);
    }
    const hasImage = urlImage && urlImage.length > 0 && urlImage[imgPosition];

    return (
        <ContImgCard url={hasImage ? urlImage[imgPosition] : ''}>
            {!hasImage && <BiBox size="86px" color="#cbd5e1" />}
            <BtnOptionsCard onClick={() => toggleMenu(true)}>
                <BiDotsVerticalRounded />
            </BtnOptionsCard>
            {
                imgPosition > 0 && (
                    <BtnNextImg onClick={() => backImg()}>
                        <BiChevronLeft />
                    </BtnNextImg>
                )
            }
            {
                (urlImage?.length > 1 && imgPosition < urlImage.length - 1) && (
                    <BtnNextImg l="auto" r="10px" onClick={() => nextImg()}>
                        <BiChevronRight />
                    </BtnNextImg>
                )
            }
            <ContIconsInfo>
                {
                    dataIconInfo.isFullyLinked && (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Producto Sincronizado</Tooltip>}
                        >
                            <ContIconInfo mr="5px">
                                <BiLinkAlt />
                            </ContIconInfo>
                        </OverlayTrigger>
                    ) 
                }
                {
                    dataIconInfo.hasVariants && (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Producto con Variantes</Tooltip>}
                        >
                            <ContIconInfo mr="5px">
                                <BiPackage />
                            </ContIconInfo>
                        </OverlayTrigger>
                    )

                }
                {
                    dataIconInfo.isVariant && (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Variante de Producto</Tooltip>}
                        >
                            <ContIconInfo>
                                <BiOutline />
                            </ContIconInfo>
                        </OverlayTrigger>
                    )
                }
            </ContIconsInfo>
        </ContImgCard>
    )
}
